
import barba from '@barba/core';
import anime from 'animejs';

export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){
        this.heroWrapper = document.querySelector("#l-hero__wrapper")
        const heroCatch = document.querySelector("#l-hero__catch")
        const heroCatchCover01 = document.querySelector("#l-hero__catch--str-cover01")
        const heroCatchCover02 = document.querySelector("#l-hero__catch--str-cover02")
        const heroCatchSub = document.querySelector(".l-hero__catch--sub")
        if(this.heroWrapper){
            let winH = window.innerHeight
            let timeoutId
            let is_scroll = false
            this.heroWrapper.style.height = winH + "px"
            //this.heroWrapperWrapper.style.height = winH + "px"
            window.addEventListener("resize", () => {
                if( is_scroll ){
                    return false
                }
                let winH = window.innerHeight
                this.heroWrapper.style.height = winH + "px"
                //this.heroWrapperWrapper.style.height = winH + "px"
                
            })
            window.addEventListener("scroll", () => {
                is_scroll = true
                clearTimeout( timeoutId ) ;
                timeoutId = setTimeout(() => {
                    if( is_scroll ){
                        is_scroll = false
                    }
                }, 1000);
            })
        }
        if(heroCatch){
            setTimeout(function(){
                heroCatch.classList.add('active');
            },1200)
			if(heroCatchCover01){
                setTimeout(function(){
                    heroCatchCover01.classList.add('active');
                },1800)
            }
            if(heroCatchCover02){
                setTimeout(function(){
                    heroCatchCover02.classList.add('active');
                },2100)
            }
        }
    }
}